export const FONT_FAMILY = '"IBM Plex Sans", "IBM Plex Sans Arabic", -apple-system, system-ui, sans-serif';
